module.exports = __webpack_public_path__ + "media/application/images/svgs/icon-linkedin-97ce31c8546f65bd1e25afbbf86ec1de.svg";